<template>
  <div>
    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="20" viewBox="0 0 17 20" fill="currentColor">
      <path
        d="M9.58385 1.20981C9.35297 0.507799 8.69137 0 7.91302 0C7.13467 0 6.47307 0.507799 6.24219 1.20981C7.33633 0.943899 8.48881 0.943712 9.58385 1.20981Z"
        fill="currentColor" />
      <path d="M10.3651 17.8496H5.45703C6.6314 19.5946 9.19012 19.5955 10.3651 17.8496Z" fill="currentColor" />
      <path
        d="M15.059 14.2697C14.3083 13.7694 13.86 12.9319 13.86 12.0297V10.7024H8.89543C7.75372 10.7024 6.82494 9.77361 6.82494 8.63191C6.82494 8.27529 6.91775 7.92316 7.09287 7.61294L9.98025 2.50464C9.33549 2.2644 8.63797 2.13306 7.91014 2.13306C4.62947 2.13306 1.96025 4.80227 1.96025 8.08294V12.0297C1.96025 12.9319 1.51196 13.7694 0.761296 14.2697C0.387464 14.5189 0.164062 14.9362 0.164062 15.386C0.164062 16.1254 0.765787 16.7271 1.50522 16.7271H14.3151C15.0545 16.7271 15.6562 16.1254 15.6562 15.386C15.6562 14.9362 15.4328 14.5189 15.059 14.2697Z"
        fill="currentColors" />
      <path
        d="M16.8041 8.16518L13.3296 2.01809C12.9372 1.32386 11.9352 1.32424 11.543 2.01809L8.06852 8.16518C7.71459 8.79142 8.16428 9.57976 8.8939 9.57976H15.9787C16.707 9.57976 17.1589 8.79288 16.8041 8.16518ZM11.875 4.19118C11.875 3.88119 12.1263 3.62987 12.4363 3.62987C12.7463 3.62987 12.9976 3.88119 12.9976 4.19118V5.68801C12.9976 5.998 12.7463 6.24932 12.4363 6.24932C12.1263 6.24932 11.875 5.998 11.875 5.68801V4.19118ZM12.4363 8.0457C12.1263 8.0457 11.8748 7.7942 11.8748 7.4842C11.8748 7.17421 12.1263 6.92271 12.4363 6.92271C12.7463 6.92271 12.9978 7.17421 12.9978 7.4842C12.9978 7.7942 12.7463 8.0457 12.4363 8.0457Z"
        fill="currentColor" />
    </svg>
  </div>
</template>

<script>
export default {
};
</script>
